/**
 * Collapses the header's nav links behind a hamburger toggle below the .site-header mobile
 * breakpoint (860px, see theme.css).
 */
export function initMobileNav(): void {
    const header = document.querySelector<HTMLElement>("[data-mobile-nav]");
    const toggle = header?.querySelector<HTMLButtonElement>("[data-mobile-nav-toggle]");

    if(header && toggle) {
        toggle.addEventListener("click", () => {
            const isOpen = header.hasAttribute("data-mobile-nav-open");

            header.toggleAttribute("data-mobile-nav-open", !isOpen);
            toggle.setAttribute("aria-expanded", String(!isOpen));
        });

        // Close the menu again once a nav link is followed, rather than leaving it open behind
        // the next page's own (freshly collapsed) header.
        header.querySelector(".site-header__nav")?.addEventListener("click", event => {
            if((event.target as HTMLElement).closest("a")) {
                header.removeAttribute("data-mobile-nav-open");
                toggle.setAttribute("aria-expanded", "false");
            }
        });
    }

    // Same pattern for the static docs page's own left-hand nav (only present on documentation
    // pages, hence the separate optional lookup).
    const docShell = document.querySelector<HTMLElement>("[data-doc-nav-shell]");
    const docNavToggle = docShell?.querySelector<HTMLButtonElement>("[data-doc-nav-toggle]");

    if(docShell && docNavToggle) {
        docNavToggle.addEventListener("click", () => {
            const isOpen = docShell.hasAttribute("data-doc-nav-open");

            docShell.toggleAttribute("data-doc-nav-open", !isOpen);
            docNavToggle.setAttribute("aria-expanded", String(!isOpen));
        });
    }
}
